import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnGY: CultureInfo = {
  name: 'en-GY',
  displayName: 'English (Guyana)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-GY',
  parent: CultureInfoEn
};
